import {
    STOCKSTATUS
} from '../types';

export function stockstatusaction(status) {
    return {
        type: STOCKSTATUS,
        status
    }
}